import React, {useEffect, useState, useContext} from 'react';

import RecentlyCommentedItem from '~/src/components/teaser/recently/item/RecentlyCommentedItem';
import Clock from '~/src/components/svg/general/Clock';
import {trackGtm} from '~/src/utilities/tracking/gtm';
import {GtmEvents} from '~/src/utilities/constants/tracking';
import {fetchActivities} from '~/src/utilities/helpers/activities';
import initPolyglot from '~/src/utilities/libs/polyglot';
import {Time} from '~/src/utilities/constants/time';
import PageContext from '~/src/components/context/PageContext';

import css from './TeaserRecentlyCommented.module.scss';
import i18n from './TeaserRecentlyCommented.i18n.json';

const getTranslation = initPolyglot(i18n);

interface Props {
    size?: number;
    className?: string;
}

const shouldFetchData = () => window.matchMedia(`(min-width: ${css.breakpointDesktop})`).matches;

const TeaserRecentlyCommented = ({size = 5, className}: Props) => {
    const [teasers, setTeasers] = useState(new Array(size).fill({content: {}, comment: {}}));
    const [fetchData, setFetchData] = useState(process.browser && shouldFetchData());
    const {gtmPageType} = useContext(PageContext);

    if (process.browser) {
        useEffect(() => {
            if (fetchData) {
                const fetcher = () =>
                    fetchActivities({limit: size}).then((data) => {
                        if (data) {
                            setTeasers(data);
                        }
                    });

                fetcher();
                const intervalId = setInterval(fetcher, Time.TEN_SECONDS);

                return () => clearInterval(intervalId);
            }
        }, [fetchData]);

        useEffect(() => {
            const onResize = () => setFetchData(shouldFetchData());
            window.addEventListener('resize', onResize);

            return () => window.removeEventListener('resize', onResize);
        }, []);
    }

    return (
        <article className={[className, css.multiColorBorder].join(' ')}>
            <div className={css.container}>
                <header className={css.header}>
                    <Clock />
                    <h1 className={css.title}>{getTranslation('title')}</h1>
                </header>
                <section className={css.teaserSection}>
                    {teasers.map((teaser, index) => (
                        <RecentlyCommentedItem
                            key={index}
                            {...teaser}
                            className={css.teaser}
                            onClick={() => trackGtm(GtmEvents.WIDGET_RECENTLY_COMMENTED, {...teaser.content, position: index, pageType: gtmPageType})}
                        />
                    ))}
                </section>
            </div>
        </article>
    );
};

export default TeaserRecentlyCommented;
